<!-- #region Add Update modal -->
<p-sidebar [(visible)]="showaddUpdateModal" [isChildCall]="isChildCall" [position]="'right'"
    (onHide)="closePaymentDialogue()" [dismissible]="false" [style]="{width:'60rem'}">
    <ng-template pTemplate="header">
        <h3>Booking</h3>
    </ng-template>
    <ng-template pTemplate="content">
        <app-booking-addupdate [bookingRelatedData]="bookingSupportData"
            (changeModalStatus)="changeAddUpdateModelState($event)" [context]="context"></app-booking-addupdate>
    </ng-template>
</p-sidebar>
<!-- #endregion  -->

<!-- #region Booking List -->
<app-booking-list [bookingListData]="recordList" (changeModelStatus)="changeAddUpdateModelState($event)"
    (changeDocumentModelStatus)="changeDocumentModalState(true,$event)"></app-booking-list>
<!-- #endregion -->

<!-- #region Documents -->
<p-sidebar [(visible)]="showDocumentModal" position="right" [dismissible]="false" [style]="{width:'90rem'}">
    <ng-template pTemplate="header">
        <h3>Documents</h3>
    </ng-template>
    <ng-template pTemplate="content">
        <app-booking-documents [currentBooking]="selectedRecord"></app-booking-documents>
    </ng-template>
</p-sidebar>
<!-- #endregion -->